export default "__VITE_ASSET__BQIAkJIK__"